import React from 'react';
import { Link } from 'react-router-dom';

const E  = '#7C4DFF';
const ED = '#6030E8';

export default function Footer() {
  return (
    <footer style={{ background: '#061829', borderTop: '1px solid rgba(124,77,255,0.12)', padding: '56px 0 24px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: 40, marginBottom: 48 }}>

          {/* Brand */}
          <div>
            <div style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 800, fontSize: '1.5rem', color: '#fff', marginBottom: 14 }}>
              Dennis<span style={{ color: E }}>.</span>
            </div>
            <p style={{ color: 'rgba(255,255,255,0.42)', fontSize: '0.88rem', lineHeight: 1.9, maxWidth: 320 }}>
              Development professional specializing in digital financial services and inclusive economic programs across Sub-Saharan Africa.
            </p>
            <div style={{ display: 'flex', gap: 10, marginTop: 22 }}>
              {[
                { icon: 'fab fa-linkedin', href: 'https://www.linkedin.com/in/denniskuria/' },
                { icon: 'fab fa-tiktok',   href: '#' /* TODO: add TikTok profile URL */ },
                { icon: 'fab fa-youtube',  href: '#' /* TODO: add YouTube channel URL */ },
                { icon: 'fas fa-globe',    href: 'https://moneyconstant.com' },
                { icon: 'fas fa-envelope', href: 'mailto:info@moneyconstant.com' },
              ].map((s, i) => (
                <a key={i} href={s.href} target="_blank" rel="noreferrer" style={{
                  width: 38, height: 38, borderRadius: 8,
                  background: 'rgba(255,255,255,0.07)', display: 'flex',
                  alignItems: 'center', justifyContent: 'center',
                  color: 'rgba(255,255,255,0.45)', transition: 'all 0.2s',
                  border: '1px solid rgba(255,255,255,0.08)',
                }}
                  onMouseEnter={e => { e.currentTarget.style.background = E; e.currentTarget.style.color = '#fff'; e.currentTarget.style.borderColor = E; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.07)'; e.currentTarget.style.color = 'rgba(255,255,255,0.45)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; }}
                >
                  <i className={s.icon} style={{ fontSize: '0.9rem' }} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ color: '#fff', fontWeight: 700, fontSize: '0.95rem', marginBottom: 18, letterSpacing: '0.5px' }}>Quick Links</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {[
                { label: 'About',      href: '/#about' },
                { label: 'Experience', href: '/#experience' },
                { label: 'Projects',   href: '/#projects' },
                { label: 'Blog',       href: '/blog' },
                { label: 'Contact',    href: '/#contact' },
              ].map(l => (
                <a key={l.label} href={l.href} style={{ color: 'rgba(255,255,255,0.42)', fontSize: '0.88rem', transition: 'color 0.2s' }}
                  onMouseEnter={e => { e.target.style.color = E; }}
                  onMouseLeave={e => { e.target.style.color = 'rgba(255,255,255,0.42)'; }}
                >
                  {l.label}
                </a>
              ))}
            </div>
          </div>

          {/* Admin */}
          <div>
            <h4 style={{ color: '#fff', fontWeight: 700, fontSize: '0.95rem', marginBottom: 18, letterSpacing: '0.5px' }}>Admin</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <Link to="/admin/login" style={{ color: 'rgba(255,255,255,0.42)', fontSize: '0.88rem', transition: 'color 0.2s' }}
                onMouseEnter={e => { e.target.style.color = E; }}
                onMouseLeave={e => { e.target.style.color = 'rgba(255,255,255,0.42)'; }}
              >
                Admin Login
              </Link>
            </div>
          </div>
        </div>

        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.07)', paddingTop: 22,
          display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8,
        }}>
          <span style={{ color: 'rgba(255,255,255,0.28)', fontSize: '0.82rem' }}>
            © {new Date().getFullYear()} Dennis Kuria. All rights reserved.
          </span>
          <span style={{ color: 'rgba(255,255,255,0.18)', fontSize: '0.78rem' }}>
            Built with React
          </span>
        </div>

        <p style={{
          color: 'rgba(255,255,255,0.24)', fontSize: '0.76rem', lineHeight: 1.7,
          textAlign: 'center', marginTop: 18, maxWidth: 720, marginLeft: 'auto', marginRight: 'auto',
        }}>
          Disclaimer: The views and opinions expressed on this site are my own and do not necessarily
          reflect those of my current or previous employers or clients.
        </p>
      </div>

      <style>{`
        @media (max-width: 768px) {
          footer > div > div:first-child { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </footer>
  );
}
